import { render, staticRenderFns } from "./ProductCardSearchVersionComponent.vue?vue&type=template&id=f8658740"
import script from "./ProductCardSearchVersionComponent.vue?vue&type=script&lang=js"
export * from "./ProductCardSearchVersionComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductCardSearchVersionComponent.vue?vue&type=style&index=0&id=f8658740&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports